import Container from "../Container"
import Heading from "../Heading"
import NewAccordion from "../NewAccordion"

const SectionAccordion = ({ section }: any) => {
  const { title, listItems, tags } = section
  return (
    <Container
      fullWidthOnMobile={false}
      constrainedToBreakPoint
      className="w-full"
    >
      <Heading as="h2" className="text-center text-blue-500">
        {title}
      </Heading>

      <dl className="text-left mt-12 divide-y divide-gray-100 border-y border-gray-100">
        <NewAccordion data={listItems} tags={tags} />
      </dl>
    </Container>
  )
}

export default SectionAccordion
